import React from "react"



export const StatsRoot = () => {
    return (
        <div>
            <h1>Stats</h1>
        </div>
    )
}
